import { Route } from "@angular/router";
import { RegulamentosPage } from "./regulamentos.page";

export const RegulamentosRouter: Route[] = [
  { path: 'regulamentos', component: RegulamentosPage }
];
